export default __webpack_public_path__ + "static/media/IMG_5103_min.963bdbb5.png";